export class ContentSearchFeed {
  idadvisioriesViewAllLink: any;
  id: any;
  label: any;
  searchDisclaimer: any;
  travelInfoLabel: any;
  traveInfoNewWindow: any;
  searchLabel: any;
  popularLabel: any;
  popularTopics: ContentPopularTopic[];
  newsViewAllLink: any;
  advisioriesLabel: any;
  viewAllLabel: any;
  noResultText: any;
  advisoriesViewNewWindow: any;
  searchFloatingLabel: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['searchDisclaimer']) {
        this.searchDisclaimer = contentjson['searchDisclaimer'];
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['travelInfoLabel']) {
        this.travelInfoLabel = contentjson['travelInfoLabel'];
      }
      if (contentjson['searchLabel']) {
        this.searchLabel = contentjson['searchLabel'];
      }
      if (contentjson['searchFloatingLabel']) {
        this.searchFloatingLabel = contentjson['searchFloatingLabel'];
      }
      if (contentjson['noResultText']) {
        this.noResultText = contentjson['noResultText'];
      }
      if (contentjson['traveInfoNewWindow']) {
        this.traveInfoNewWindow = contentjson['traveInfoNewWindow'];
      }
      if (contentjson['popularLabel']) {
        this.popularLabel = contentjson['popularLabel'];
      } else {
        this.popularLabel = '';
      }
      if (contentjson['newsViewAllLink']) {
        this.newsViewAllLink = contentjson['newsViewAllLink'];
      } else {
        this.newsViewAllLink = '';
      }
      if (contentjson['advisoriesLabel']) {
        this.advisioriesLabel = contentjson['advisoriesLabel'];
      } else {
        this.advisioriesLabel = '';
      }
      if (contentjson['viewAllLabel']) {
        this.viewAllLabel = contentjson['viewAllLabel'];
      } else {
        this.viewAllLabel = '';
      }
      if (contentjson['advisoriesViewNewWindow']) {
        this.advisoriesViewNewWindow = contentjson['advisoriesViewNewWindow'];
      } else {
        this.advisoriesViewNewWindow = '';
      }
      if (contentjson['popularTopics']) {
        this.popularTopics = this.fillPopularTopic(
          contentjson['popularTopics']
        );
      }
    }
  }

  private fillPopularTopic(contentjson?: any): ContentPopularTopic[] {
    let populartopic: ContentPopularTopic[] = [];
    const items = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      let counter = 1;
      for (const value of values) {
        items.set(counter, new ContentPopularTopic(value));
        counter++;
      }
      populartopic = Array.from(items.values());
    }
    return populartopic;
  }
}

export class ContentPopularTopic {
  populartopicsTitle: any;
  populartopicsLink: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      this.populartopicsTitle = contentjson['populartopicsTitle'];
      this.populartopicsLink = contentjson['populartopicsLink'];
    } else {
      this.populartopicsTitle = null;
      this.populartopicsLink = null;
    }
  }
}
